@if (loading) {
    <div class="text-center" style="margin-top: 50px">
        <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
    </div>
} @else if (report) {
    <div class="page-header as-header">
        <h1 class="as-title"
            >{{ report.displayName }}
            @if (report.variantName) {
                <span> - {{ report.variantName }}</span>
            }
        </h1>
        <div class="as-header-functions" style="padding-top: 6px; padding-bottom: 0px">
            <div>
                @if (showRevokeReportButton()) {
                    <button
                        class="ace-btn has-icon btn-text icon-dark"
                        (click)="revokeReportShare()"
                        title="Stop Sharing"
                    >
                        <i class="fa fa-share-alt fa-lg" aria-hidden="true"></i>
                    </button>
                }
            </div>
            <div>
                <button class="ace-btn has-icon btn-text icon-dark" (click)="refresh()" title="Reload">
                    <i class="fa fa-refresh fa-lg"></i>
                </button>
            </div>
            @if (saveVisible) {
                <div>
                    <button class="ace-btn has-icon btn-text icon-dark" (click)="saveReport()" title="Save">
                        <i class="fa fa-save fa-lg"></i>
                    </button>
                </div>
            }
            @if (saveAsVisible) {
                <div
                    helpTooltip
                    [helpContentId]="
                        isSingleInstanceSelected ? 'report-manager.save-as' : 'report-manager.all-instances-selected'
                    "
                >
                    <button
                        class="ace-btn has-icon btn-text icon-dark ws-vertical-align-middle"
                        (click)="saveReportAs()"
                        [disabled]="!isSingleInstanceSelected"
                    >
                        <ws-save-as-icon class="ws-stretch"></ws-save-as-icon>
                    </button>
                </div>
            }
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            @if (report.reportTypeId === reportTypes.UserAccess) {
                <div style="margin-bottom: 20px">
                    <label class="radio-inline">
                        <input
                            type="radio"
                            name="start-with"
                            [(ngModel)]="report.criteria.startWith"
                            [value]="StartWithEnum.Company"
                        />
                        Start with Company
                    </label>
                    <label class="radio-inline">
                        <input
                            type="radio"
                            name="start-with"
                            [(ngModel)]="report.criteria.startWith"
                            [value]="StartWithEnum.SingleUser"
                        />
                        Start with Single User
                    </label>
                </div>
            }
            @if (
                report.criteria.startWith === StartWithEnum.SingleUser || report.reportTypeId === reportTypes.UserCSR
            ) {
                <div style="margin-bottom: 20px; width: 300px">
                    <user-picker
                        [search]="userSearch"
                        [currentContact]="report.criteria.selectedContact"
                        [includeCompany]="true"
                        [usersOnly]="true"
                        (contactChanged)="setSelectedContact($event)"
                    ></user-picker>
                </div>
            }
            @if (showEntitiesSelector) {
                <report-manager-select-entities
                    [report]="report"
                    [entitySelection]="report.criteria.entitySelection"
                    [hideTopLevelCompanyPicker]="report.criteria.hideTopLevelCompanyPicker"
                    [showSupportInstancePicker]="report.criteria.showSupportInstancePicker"
                    (reportFavoriteChange)="updateFavoriteStatus($event)"
                >
                </report-manager-select-entities>
            }
        </div>
    </div>

    @if (report.reportTypeId !== reportTypes.UserCSR) {
        <div class="row">
            <div class="col-lg-12">
                <div class="card panel-flat-color secondary-panel">
                    <div class="panel-flat-header" style="margin-bottom: 0">
                        <div class="header-icon">
                            <i class="fa fa-filter"></i>
                        </div>
                        @if (report.reportTypeId !== reportTypes.ReturnScheduleSummary) {
                            <h3>Further Limit the Contents of your Report</h3>
                        }
                        @if (report.reportTypeId === reportTypes.ReturnScheduleSummary) {
                            <h3>Limit the Report Content</h3>
                        }
                    </div>
                    <div class="panel-flat-body" style="min-height: 80px">
                        <div style="margin-top: 10px">
                            @if (report.reportTypeId === reportTypes.ProjectStatus) {
                                <further-limit-panel-psr
                                    [report]="report"
                                    [availableYears]="availableYears"
                                    [hasRyanPrivatePermission]="hasRyanPrivatePermission"
                                ></further-limit-panel-psr>
                            }
                            @if (report.reportTypeId === reportTypes.AppealRecommendation) {
                                <further-limit-panel-psr
                                    [report]="report"
                                    [availableYears]="availableYears"
                                    [hasRyanPrivatePermission]="hasRyanPrivatePermission"
                                ></further-limit-panel-psr>
                            }
                            @if (report.reportTypeId === reportTypes.Site) {
                                <further-limit-panel-site
                                    [report]="report"
                                    [availableYears]="availableYears"
                                    [hasRyanPrivatePermission]="hasRyanPrivatePermission"
                                ></further-limit-panel-site>
                            }
                            @if (report.reportTypeId === reportTypes.Budget) {
                                <further-limit-panel-budget
                                    [report]="report"
                                    [availableYears]="availableYears"
                                    [hasRyanPrivatePermission]="hasRyanPrivatePermission"
                                ></further-limit-panel-budget>
                            }
                            @if (report.reportTypeId === reportTypes.BudgetVariance) {
                                <further-limit-panel-budget-variance
                                    [report]="report"
                                    [hasRyanPrivatePermission]="hasRyanPrivatePermission"
                                ></further-limit-panel-budget-variance>
                            }
                            @if (report.reportTypeId === reportTypes.Maar) {
                                <further-limit-panel-maar
                                    [report]="report"
                                    [availableYears]="availableYears"
                                ></further-limit-panel-maar>
                            }
                            @if (report.reportTypeId === reportTypes.ProgressStatus) {
                                <further-limit-panel-progress-status
                                    [report]="report"
                                    [availableYears]="availableYears"
                                ></further-limit-panel-progress-status>
                            }
                            @if (report.reportTypeId === reportTypes.ReturnScheduleSummary) {
                                <further-limit-panel-schedules-summary
                                    [report]="report"
                                    [modalParameters]="modalParameters"
                                ></further-limit-panel-schedules-summary>
                            }
                            @if (report.reportTypeId === reportTypes.ReturnAssetDetail) {
                                <further-limit-panel-asset-detail
                                    [report]="report"
                                    [modalParameters]="modalParameters"
                                ></further-limit-panel-asset-detail>
                            }
                            @if (report.reportTypeId === reportTypes.UserActivity) {
                                <further-limit-panel-user-activity [report]="report"></further-limit-panel-user-activity>
                            }
                            @if (report.reportTypeId === reportTypes.UserAccess) {
                                <further-limit-panel-user-activity [report]="report"></further-limit-panel-user-activity>
                            }
                            @if (report.reportTypeId === reportTypes.SupportInstanceEscalationActivity) {
                                <further-limit-panel-support-instance-escalation-activity
                                    [report]="report"
                                ></further-limit-panel-support-instance-escalation-activity>
                            }
                            @if (
                                report.reportTypeId === reportTypes.InitialValue ||
                                report.reportTypeId === reportTypes.FinalValue ||
                                report.reportTypeId === reportTypes.ARBValue ||
                                report.reportTypeId === reportTypes.ARBCoverLetter
                            ) {
                                <further-limit-panel-value
                                    [report]="report"
                                    [availableYears]="availableYears"
                                ></further-limit-panel-value>
                            }
                            @if (report.reportTypeId === reportTypes.TaxSavings) {
                                <further-limit-panel-tax-savings
                                    [report]="report"
                                    [availableYears]="availableYears"
                                ></further-limit-panel-tax-savings>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    @if (
        report.reportTypeId !== reportTypes.ProgressStatus &&
        report.reportTypeId !== reportTypes.Maar &&
        report.reportTypeId !== reportTypes.UserCSR
    ) {
        <div class="row">
            <div class="col-lg-12">
                <div class="card panel-flat-color secondary-panel">
                    <div class="panel-flat-header" style="margin-bottom: 0">
                        <div class="header-icon">
                            <i class="fa fa-file-text-o"></i>
                        </div>
                        <h3>Format the Report Output</h3>
                        <div class="float-end"> </div>
                    </div>
                    @if (report.reportTypeId === reportTypes.ProjectStatus) {
                        <format-output-panel-psr [report]="report"></format-output-panel-psr>
                    }
                    @if (report.reportTypeId === reportTypes.AppealRecommendation) {
                        <format-output-panel-psr [report]="report"></format-output-panel-psr>
                    }
                    @if (report.reportTypeId === reportTypes.Site) {
                        <format-output-panel-site [report]="report"></format-output-panel-site>
                    }
                    @if (report.reportTypeId === reportTypes.Budget) {
                        <format-output-panel-budget [report]="report"></format-output-panel-budget>
                    }
                    @if (report.reportTypeId === reportTypes.BudgetVariance) {
                        <format-output-panel-budget-variance [report]="report"></format-output-panel-budget-variance>
                    }
                    @if (report.reportTypeId === reportTypes.ReturnScheduleSummary) {
                        <format-output-panel-schedules-summary
                            [report]="report"
                            [scheduleName]="report.criteria.scheduleName"
                        ></format-output-panel-schedules-summary>
                    }
                    @if (report.reportTypeId === reportTypes.ReturnAssetDetail) {
                        <format-output-panel-asset-detail
                            [(report)]="report"
                            [modalParameters]="modalParameters"
                            [scheduleName]="report.criteria.scheduleName"
                            [priorReturnStatusName]="report.criteria.priorReturnStatusName"
                        ></format-output-panel-asset-detail>
                    }
                    @if (report.reportTypeId === reportTypes.UserActivity) {
                        <format-output-panel-user-activity [report]="report"></format-output-panel-user-activity>
                    }
                    @if (report.reportTypeId === reportTypes.UserAccess) {
                        <format-output-panel-user-activity [report]="report"></format-output-panel-user-activity>
                    }
                    @if (report.reportTypeId === reportTypes.SupportInstanceEscalationActivity) {
                        <format-output-panel-support-instance-escalation-activity
                            [report]="report"
                        ></format-output-panel-support-instance-escalation-activity>
                    }
                    @if (
                        report.reportTypeId === reportTypes.InitialValue ||
                        report.reportTypeId === reportTypes.FinalValue ||
                        report.reportTypeId === reportTypes.ARBValue ||
                        report.reportTypeId === reportTypes.ARBCoverLetter
                    ) {
                        <format-output-panel-value [report]="report"></format-output-panel-value>
                    }
                    @if (report.reportTypeId === reportTypes.TaxSavings) {
                        <format-output-panel-tax-savings [report]="report"></format-output-panel-tax-savings>
                    }
                </div>
            </div>
        </div>
    }

    @if (showRequestReportButton()) {
        <div class="float-end" style="margin-bottom: 20px">
            <button class="ace-btn btn-primary" [disabled]="requestButtonIsDisabled" (click)="requestReport()"
                >Request Report
            </button>
        </div>
    }
}
